import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import Vue from 'vue'
import { mapState } from "vuex"; // const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

var mixin = {
  computed: _objectSpread({}, mapState({
    layoutMode: function layoutMode(state) {
      return state.app.layout;
    },
    navTheme: function navTheme(state) {
      return state.app.theme;
    },
    primaryColor: function primaryColor(state) {
      return state.app.color;
    },
    colorWeak: function colorWeak(state) {
      return state.app.weak;
    },
    multipage: function multipage(state) {
      return state.app.multipage;
    },
    //多页签设置
    fixedHeader: function fixedHeader(state) {
      return state.app.fixedHeader;
    },
    fixSiderbar: function fixSiderbar(state) {
      return state.app.fixSiderbar;
    },
    contentWidth: function contentWidth(state) {
      return state.app.contentWidth;
    },
    autoHideHeader: function autoHideHeader(state) {
      return state.app.autoHideHeader;
    },
    sidebarOpened: function sidebarOpened(state) {
      return state.app.sidebar.opened;
    }
  }))
};
var mixinDevice = {
  computed: _objectSpread({}, mapState({
    device: function device(state) {
      return state.app.device;
    }
  })),
  methods: {
    isMobile: function isMobile() {
      return this.device === 'mobile';
    },
    isDesktop: function isDesktop() {
      return this.device === 'desktop';
    }
  }
};
export { mixin, mixinDevice };